export const QuoteSymbolMap = {
	USDT: "$",
	BTC: "₿",
	TRY: "₺",
};
